import { Utils } from "./Utils";
class LockFunction {
    #flag = false;
    #delayTime = 0;
    #callback;
    #context;
    lock;
    unlock;
    run;
    isLock;
    constructor(callback, context, delayTime) {
        let that = this;
        this.#callback = callback;
        if (typeof context === "number") {
            this.#delayTime = context;
            this.#context = Utils;
        }
        else {
            this.#delayTime = delayTime;
            this.#context = context;
        }
        /**
         * 锁
         */
        this.lock = function () {
            that.#flag = true;
        };
        /**
         * 解锁
         */
        this.unlock = function () {
            setTimeout(() => {
                that.#flag = false;
            }, that.#delayTime);
        };
        /**
         * 判断是否被锁
         */
        this.isLock = function () {
            return that.#flag;
        };
        /**
         * 执行
         */
        this.run = async function (...args) {
            if (that.isLock()) {
                return;
            }
            that.lock();
            await that.#callback.apply(that.#context, args);
            that.unlock();
        };
    }
}
export { LockFunction };
